<template>
    <div class="cookies-container">
        <b-row>
            <b-col md="2" sm="12" class="align-center-sm icon-align">
                <span class="icon">
                    <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M29 14.5C29 22.5081 22.5081 29 14.5 29C6.49187 29 0 22.5081 0 14.5C0 6.49187 6.49187 0 14.5 0C22.5081 0 29 6.49187 29 14.5Z"
                            fill="#009BDB"
                        />
                        <path
                            d="M16.0282 18.0238H12.9591L12.5243 5H16.463L16.0282 18.0238ZM14.4936 20.0632C15.116 20.0632 15.6147 20.2482 15.9898 20.6182C16.3734 20.9882 16.5653 21.4615 16.5653 22.0381C16.5653 22.606 16.3734 23.075 15.9898 23.445C15.6147 23.815 15.116 24 14.4936 24C13.8798 24 13.3811 23.815 12.9975 23.445C12.6224 23.075 12.4348 22.606 12.4348 22.0381C12.4348 21.4701 12.6224 21.0011 12.9975 20.6311C13.3811 20.2525 13.8798 20.0632 14.4936 20.0632Z"
                            fill="white"
                        />
                    </svg>
                </span>
            </b-col>
            <b-col md="8" sm="12" class="align-center-sm">
                <span class="text">
                    Nossa plataforma armazena cookies para coletar informações e
                    melhorar sua experiência conosco. Conheça nossa
                    <a
                        class="privacy-policy"
                        href="http://coblue.com.br/privacidade"
                        target="_blank"
                        rel="nofollow"
                        >Poltica de privacidade</a
                    >
                    e
                    <span class="privacy-policy" @click="openCookiesModal()"
                        >Gerencie seus cookies</span
                    >.
                </span>
            </b-col>
            <b-col md="2" sm="12" class="align-center-sm button-align">
                <b-button
                    class="button-cookies"
                    size="lg"
                    variant="primary"
                    @click="handleAccept"
                    >Aceitar</b-button
                >
            </b-col>
        </b-row>

        <cookies-modal
            v-if="modalOpened"
            @modalClosed="handleClosed"
        ></cookies-modal>
    </div>
</template>

<script>
import CookiesModal from './children'
import { deleteAllCookiesMixin } from '@/mixins'

export default {
    name: 'Cookies',
    components: {
        CookiesModal,
    },
    mixins: [deleteAllCookiesMixin],
    data() {
        return {
            modalOpened: false,
            optionalCookies: true,
        }
    },

    methods: {
        openCookiesModal() {
            this.modalOpened = true
        },
        handleClosed({ optionalCookies }) {
            this.modalOpened = false
            this.optionalCookies = optionalCookies
        },
        handleAccept() {
            if (!this.optionalCookies) {
                this.deleteAllCookies()
            }

            localStorage.setItem(this.acceptedCookiesUseKey, true)
            localStorage.setItem(
                this.acceptedExternalCookiesUseKey,
                this.optionalCookies
            )

            this.$emit('userAccepted')
        },
    },
}
</script>

<style lang="sass">
$textGray: #5b5b5b

.cookies-container
    position: fixed
    left: 0
    bottom: 0
    z-index: 1000000
    background: lightgray
    width: 100%
    padding: 20px
    display: flex
    justify-content: center
    align-items: center

    .align-center-sm
        display: flex
        justify-content: center
        align-items: center
    .icon-align
        justify-content: end
    .button-align
        justify-content: start

    .text
        text-align: justify
        font-size: 20px
        .privacy-policy
            color: $textGray
            text-decoration: none
            font-weight: bold
            &:hover
                color: $textGray
                text-decoration: none
                cursor: pointer

@media screen and (max-width: 768px)
    .icon-align,
    .button-align
        justify-content: center !important
    .icon
        margin-bottom: 20px

    .button-cookies
        margin-top: 20px
</style>
